export default "__VITE_ASSET__16cb6960__"